var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.canConversationsPreserveToggle
    ? _c(
        "el-tooltip",
        { attrs: { content: _vm.getLabel, effect: "light", placement: "top" } },
        [
          _c(
            "span",
            {
              staticClass: "btn btn-secondary btn_call btn_call-sm",
              staticStyle: { padding: "0.25rem 0.65rem" },
              on: { click: _vm.togglePreserve },
            },
            [_c("i", { class: _vm.getIcon })]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }